import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function animateQuant(el) {
	if (el.classList.contains('animated')) return;

	const quant = el.querySelector('.quant');
	const quantNumber = quant.querySelector('.quant-number');
	const targetNumber = parseFloat(quant.dataset.number);
	const isDecimal = targetNumber % 1 !== 0;

	// Clear the server-rendered value synchronously; gsap's first onUpdate
	// is a tick away, and .animated lifts the CSS mask immediately.
	quantNumber.textContent = '0';

	let current = { value: 0 };

	gsap.to(current, {
		value: targetNumber,
		duration: 2,
		ease: 'power2.out',
		onUpdate: () => {
			const formatted = isDecimal ? current.value.toFixed(1) : Math.ceil(current.value);
			quantNumber.textContent = formatted;
		}
	});

	el.classList.add('animated');
}

document.addEventListener('DOMContentLoaded', () => {
	const wrappers = document.querySelectorAll('.quant-wrapper');

	if (wrappers.length) {
		wrappers.forEach((element) => {
			ScrollTrigger.create({
				trigger: element,
				start: 'bottom bottom',
				onEnter: () => animateQuant(element),
			});
		});
	}
});
